import { LottieContainer } from 'components/animations/LottieContainer.tsx';
import animationDataSuccess from '../../assets/animations/loader_big.json';
import animationDataFailure from '../../assets/animations/loader_big_error.json';
import clsx from 'clsx';
import pageStyles from './LoadingPage.module.scss';
import React from 'react';

export type LoadingType = 'none' | 'loading' | 'completed';
export type AfterLoading = 'success' | 'failure';

type OwnProps = {
  loadingStatus: LoadingType;
  className?: string;
  titleLoadingContent?: React.ReactNode;
  titleContent?: React.ReactNode;
  bodyContent?: React.ReactNode;
  footerContent?: React.ReactNode;
  afterLoading?: AfterLoading;
};

export const LoadingPage = (props: OwnProps) => {
  const {
    titleLoadingContent,
    className,
    titleContent,
    bodyContent,
    footerContent,
    loadingStatus,
    afterLoading = 'success',
  } = props;

  return (
    <div
      className={clsx(
        pageStyles.loadingContainer,
        pageStyles.columnContainer,
        className,
      )}
    >
      <LottieContainer
        animationData={
          afterLoading === 'success'
            ? animationDataSuccess
            : animationDataFailure
        }
        segments={loadingStatus == 'loading' ? [1, 180] : [180, 300]}
        loop={loadingStatus == 'loading'}
      />
      {loadingStatus == 'loading' ? (
        <div className={clsx(pageStyles.marginTop30)}>
          <div className={pageStyles.loadingTitle}>
            {titleLoadingContent && titleLoadingContent}
          </div>
        </div>
      ) : (
        <div
          className={clsx(
            pageStyles.columnContainer,
            pageStyles.marginTop30,
            pageStyles.alignItemsCenter,
          )}
        >
          <div
            className={clsx(pageStyles.loadingTitle, pageStyles.marginBottom10)}
          >
            {titleContent}
          </div>
          <div className={pageStyles.bodyContent}> {bodyContent}</div>
          <div
            className={clsx(pageStyles.rowContainer12, pageStyles.marginTop80)}
          >
            {footerContent}
          </div>
        </div>
      )}
    </div>
  );
};
